import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'tdesign-react';
import { fetchStorages } from '@/slices/topicSlice';
import { isEmpty } from '@/utils/common';
import ModalHeader from '@/components/Header/Modal';
import Descriptions from '@/components/Descriptions';
import JSONModal from '@/components/JSONModal';
import PartitionSelect from '../components/PartitionSelect';
import Charts from './Charts';
import Ledgers from './Ledgers';
import Cursors from './Cursors';

function StoragePanel({ commonProps, fetchStorages, overview, storage }) {
  const [currentPart, setCurrentPart] = useState();
  const [visible, setVisible] = useState(false);
  const isPartition = overview.topicPartitionCount > 0;

  useEffect(() => {
    if (!isPartition) {
      fetchStorages(commonProps);
    } else if (!isEmpty(currentPart)) {
      fetchStorages({
        ...commonProps,
        partition: currentPart,
      });
    }
  }, [currentPart, fetchStorages, commonProps, isPartition]);

  return (
    <Root>
      <Header>
        <Left>
          {isPartition && (
            <PartitionSelect
              currentPart={currentPart}
              onChange={setCurrentPart}
              style={{ marginTop: 3 }}
            />
          )}
          <Charts />
        </Left>
        <Button onClick={() => setVisible(true)}>获取详情</Button>
      </Header>
      <Content>
        <Descriptions.Panel title='Ledgers' bordered style={{ border: 'none' }}>
          <Ledgers commonProps={commonProps} />
        </Descriptions.Panel>
        <Descriptions.Panel title='Cursors' bordered style={{ border: 'none' }}>
          <Cursors />
        </Descriptions.Panel>
      </Content>
      <JSONModal
        title={
          <ModalHeader
            tags={[
              commonProps.clusterName,
              `${overview.topic}${isPartition && `-partition-${currentPart}`}`,
            ]}
          >
            详情
          </ModalHeader>
        }
        json={storage.statsDetail}
        visible={visible}
        handleClose={() => setVisible(false)}
      />
    </Root>
  );
}
export default connect(
  (state) => ({
    overview: state.topic.detailOverview,
    storage: state.topic.storage,
  }),
  {
    fetchStorages,
  },
)(StoragePanel);

const Root = styled.div`
  padding-top: 12px;
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Left = styled.div`
  flex: 1;
`;

const Content = styled.div`
  border: 1px solid rgba(32, 43, 64, 0.08);
  border-radius: 6px;
`;
